var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nl2br',{attrs:{"text":_vm.text,"tag":"p","class-name":"detail-page-edit-item-description"}})}
var staticRenderFns = []

export { render, staticRenderFns }